import { jsx as _jsx } from "theme-ui/jsx-runtime";

/* Original name @uswitch/trustyle.usp-tag */
var UspTag = function UspTag(_ref) {
  var usp = _ref.usp,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '#E0E9FF' : _ref$backgroundColor,
      _ref$beforeColor = _ref.beforeColor,
      beforeColor = _ref$beforeColor === void 0 ? '#84A6FF' : _ref$beforeColor,
      className = _ref.className;
  return usp ? _jsx("div", {
    sx: {
      background: backgroundColor,
      textAlign: 'left',
      paddingX: 12,
      paddingY: 4,
      '::before': {
        content: '""',
        position: 'relative',
        left: '-.55em',
        borderLeft: "4px solid ".concat(beforeColor),
        paddingY: '.2em'
      }
    },
    className: className,
    children: _jsx("span", {
      sx: {
        fontFamily: 'base',
        fontWeight: 'bold',
        fontSize: 'xxs',
        color: 'grey-80',
        lineHeight: 1.3
      },
      children: usp
    })
  }) : null;
};

export default UspTag;
//# sourceMappingURL=usp-tag.js.map